const FILE_ICONS = {
  'application/pdf': 'bi bi-file-earmark-pdf-fill',
  'PDF':             'bi bi-file-earmark-pdf-fill',
  'image/png':       'bi bi-image-fill',
  'image/jpeg':      'bi bi-image-fill',
  'Image':           'bi bi-image-fill',
}

const DEFAULT_ICON = 'bi bi-file-earmark-word-fill'

function GetFileIcon(mimeType) {
  return FILE_ICONS[mimeType] ?? DEFAULT_ICON
}

function FormatDateForForm(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ')
}

export default {
    GetFileIcon, FormatDateForForm
}